import { Card, Col, FormLabel, Row } from "react-bootstrap";
import { studentString } from "../../../utils/string";
import { CustomSelectWhite } from "../../custom/Select/CustomSelectWhite";
import { KTSVG } from "../../../_uLearn/helpers";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import StudentDetails from "../../modals/student-details";
import { PAGE_LIMIT } from "../../../utils/constants";
import APICallService from "../../../api/apiCallService";
import { MASTER, SCHOOL, STUDENT } from "../../../api/apiEndPoints";
import { studentJSON } from "../../../api/apiJSON/student";
import Loader from "../../../Global/loader";
import defaultImg from "../../../_uLearn/assets/media/svg_uLearn/default.svg";
import Method from "../../../utils/methods";
import Pagination from "../../../Global/pagination";
import { useDebounce } from "../../../utils/useDebounce";
import { CustomComponentSelect } from "../../custom/Select/CustomComponentSelect";
import { getKey, removeKey, setKey } from "../../../Global/history";
import { listStudents } from "../../../utils/storeString";
const Students = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [editDetailData, setEditDetailData] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState<any>(getKey(listStudents.page) || 1);
  const [pageLimit, setPageLimit] = useState<any>(
    getKey(listStudents.limit) || PAGE_LIMIT
  );
  const [searchTerm, setSearchTerm] = useState<string>(
    getKey(listStudents.search)?.toString() || ""
  );
  const [studentData, setStudentData] = useState<any>([]);
  const [classDetails, setClassDetails] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [selectedClass, setSelectedClass] = useState<any>(
    getKey(listStudents.filterByClass) || ""
  );
  const [schoolDetails, setSchoolDetails] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState<any>(
    getKey(listStudents.filterBySchool) || ""
  );
  const [selectedClassOption, setSelectedClassOption] = useState([]);
  const [selectedSubjectList, setSelectedSubjectList] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState<any>(
    getKey(listStudents.filterBySubject) || []
  );
  useEffect(() => {
    (async () => {
      setLoading(true);
      await fetchStudent(
        page,
        pageLimit,
        searchTerm,
        selectedClass,
        selectedSchool,
        selectedSubject
      );
      await fetchClassDetails();
      await fetchSchoolDetails();
      setLoading(false);
    })();
  }, []);
  const fetchStudent = async (
    pageNo: number,
    limit: number,
    search?: string,
    className?: any,
    school?: string,
    subjects?: any
  ) => {
    setLoading(true);
    let params = {
      pageNo: pageNo,
      limit: limit,
      sortKey: "_createdAt",
      sortOrder: -1,
      searchTerm: search?.trim() || "",
      className: className && className.value.length > 0 ? className.value : "",
      school: school && school.length > 0 ? school : "",
      subjects: subjects && subjects.length ? subjects : [],
    };
    let apiService = new APICallService(
      STUDENT.GET_STUDENT_LIST,
      studentJSON.listStudent(params)
    );
    let response = await apiService.callAPI();
    if (response) {
      if (response.total) {
        setTotalRecords(response.total);
      } else {
        // let prevTotal = totalRecords;
        setTotalRecords(0);
      }
      setStudentData(response.records);
    }
    setLoading(false);
  };
  const fetchClassDetails = async () => {
    setLoading(true);
    let apiService = new APICallService(MASTER.CLASS_SUBJECT_LIST);
    let response: any = await apiService.callAPI();
    if (response) {
      setClassDetails(response.records);
    }
    setLoading(false);
  };
  const fetchSchoolDetails = async () => {
    setLoading(true);
    let apiService = new APICallService(SCHOOL.GET_SCHOOL_LIST);
    let response: any = await apiService.callAPI();
    if (response) {
      setSchoolDetails(response.records);
      const schoolId = getKey(listStudents.filterBySchool);
      const classId = getKey(listStudents.filterByClass);
      if (schoolId) {
        const temp = response.records.find((item: any) => item._id == schoolId);
        setSelectedClassOption(temp.class);
        if (classId) {
          const tempSubject = temp.class.find(
            (item: any) => item.reference == classId.value
          );
          setSelectedSubjectList(tempSubject.subjects);
        }
      }
    }
    setLoading(false);
  };
  const handleCurrentPage = async (val: number) => {
    if (val === page || val.toString() === "...") return;
    setPage(val);
    setKey(listStudents.page, val);
    await fetchStudent(
      val,
      pageLimit,
      searchTerm,
      selectedClass,
      selectedSchool,
      selectedSubject
    );
  };
  const handleNextPage = async (val: number) => {
    setPage(val + 1);
    setKey(listStudents.page, val + 1);
    await fetchStudent(
      val + 1,
      pageLimit,
      searchTerm,
      selectedClass,
      selectedSchool,
      selectedSubject
    );
  };
  const handlePreviousPage = async (val: number) => {
    setPage(val - 1);
    setKey(listStudents.page, val - 1);
    await fetchStudent(
      val - 1,
      pageLimit,
      searchTerm,
      selectedClass,
      selectedSchool,
      selectedSubject
    );
  };
  const handlePageLimit = async (event: any) => {
    setPage(1);
    await setPageLimit(parseInt(event.target.value));
    setKey(listStudents.page, 1);
    setKey(listStudents.limit, parseInt(event.target.value));
    await fetchStudent(
      1,
      event.target.value,
      searchTerm,
      selectedClass,
      selectedSchool,
      selectedSubject
    );
  };
  const handleClassChange = async (event: any) => {
    setKey(listStudents.page, 1);
    setPage(1);
    if (event) {
      setSelectedSubject([]);
      setKey(listStudents.filterByClass, event);
      await fetchStudent(1, pageLimit, searchTerm, event, selectedSchool);
      setSelectedClass(event);
      setSelectedSubjectList(event.subjects);
      setPage(1);
    } else {
      setSelectedSubject([]);
      await fetchStudent(1, pageLimit, searchTerm, "", selectedSchool);
      setSelectedClass("");
      setSelectedSubjectList([]);
      removeKey(listStudents.filterByClass);
      setPage(1);
    }
    removeKey(listStudents.filterBySubject);
  };
  const handleSchoolChange = async (event: any) => {
    setKey(listStudents.page, 1);
    setPage(1);
    if (event) {
      setSelectedClass(null);
      setSelectedSubject([]);
      setKey(listStudents.filterBySchool, event._id);
      await fetchStudent(1, pageLimit, searchTerm, selectedClass, event._id);
      setSelectedSchool(event._id);
      setSelectedClassOption(event.class);
      setPage(1);
    } else {
      setSelectedClass(null);
      setSelectedSubject([]);
      await fetchStudent(1, pageLimit, searchTerm, "", "");
      setSelectedSchool("");
      removeKey(listStudents.filterBySchool);
      setSelectedClassOption([]);
      setPage(1);
    }
    removeKey(listStudents.filterByClass);
    removeKey(listStudents.filterBySubject);
  };
  const handleSubjectChange = async (event: any) => {
    setKey(listStudents.filterBySubject, event);
    await fetchStudent(
      1,
      pageLimit,
      searchTerm,
      selectedClass,
      selectedSchool,
      event
    );
    setSelectedSubject(event);
    setPage(1);
  };
  const debounce = useDebounce(fetchStudent, 400);
  const handleSearchTerm = async (value: string) => {
    value = value.trimStart();
    //const regex = /^(\w+( \w+)*)( {0,1})$/;
    //const regex = /^(\w+( \w+)*)? ?$/;
    const regex = /^(\S+( \S+)*)? ?$/;
    const isValid = regex.test(value);
    if (!isValid) {
      return;
    }
    setSearchTerm(value);
    setKey(listStudents.page, 1);
    if (value.trim().length > 2 && searchTerm !== value) {
      setPage(1);
      setLoading(true);
      setTotalRecords(0);
      await debounce(
        1,
        pageLimit,
        value,
        selectedClass,
        selectedSchool,
        selectedSubject
      );
      setLoading(false);
      //await fetchProducts(1, pageLimit, productState, categories, input);
    } else if (value.trim().length <= 2 && value.length < searchTerm.length) {
      setPage(1);
      setLoading(true);
      setTotalRecords(0);
      await debounce(
        1,
        pageLimit,
        value,
        selectedClass,
        selectedSchool,
        selectedSubject
      );
      setLoading(false);
      // await fetchProducts(1, pageLimit, productState, categories, input);
    }
    setKey(listStudents.search, value);
  };
  const handleOnKeyUp = async (event: any) => {
    var charCode = event.which ? event.which : event.keyCode;
    const input: any = event.target.value;
    if (input[input.length - 1] === " " && charCode === 32) return;
    if (input.trim().length > 2) {
      await fetchStudent(1, 10, input);
    } else if (
      input.trim().length <= 2 &&
      (charCode === 46 || charCode === 8)
    ) {
      await fetchStudent(1, 10, input);
    }
  };
  const handleStudent = (studentVal: any) => {
    // console.log('state', { state: studentVal });
    setEditDetailData(studentVal);
    setShowDetailModal(true);
  };
  return (
    <>
      {editDetailData && showDetailModal && (
        <StudentDetails
          show={showDetailModal}
          onHide={() => setShowDetailModal(false)}
          editDetailData={editDetailData}
        />
      )}
      <Row className="align-items-center">
        <Col xs className="align-self-center mb-5">
          <h1 className="fs-22 fw-bolder mb-0">{studentString.titleStudent}</h1>
        </Col>
        <Col xs={12}>
          <Card className="bg-light border mb-7">
            <Card.Body className="px-7">
              <Row className="align-items-center g-5">
                <Col md={4} lg={3}>
                  <FormLabel className="fs-16 fw-500 text-dark">
                    {studentString.searchByKeyword}
                  </FormLabel>
                  <div className="d-flex align-items-center position-relative me-lg-4">
                    <KTSVG
                      path="/media/icons/duotune/general/gen021.svg"
                      className="svg-icon-3 position-absolute ms-3"
                    />
                    <input
                      type="text"
                      id="kt_filter_search"
                      className="form-control form-control-white min-h-60px form-control-lg ps-10"
                      placeholder="Search by student name…"
                      onChange={(e) => handleSearchTerm(e.target.value)}
                      value={searchTerm}
                      // onKeyUp={(e) => handleOnKeyUp(e)}
                    />
                  </div>
                </Col>
                <Col md={4} lg={3}>
                  <FormLabel className="fs-16 fw-500 text-dark">
                    {studentString.filterBySchool}
                  </FormLabel>
                  <CustomSelectWhite
                    options={
                      schoolDetails?.length
                        ? schoolDetails.map((val: any) => {
                            return {
                              value: val._id,
                              label: val.name,
                              _id: val._id,
                              class: val.class,
                            };
                          })
                        : []
                    }
                    onChange={(event: any) => {
                      handleSchoolChange(event);
                    }}
                    isClearable={true}
                    isMulti={false}
                    value={schoolDetails
                      .map((val: any) => {
                        return {
                          value: val._id,
                          label: val.name,
                          _id: val._id,
                          class: val.class,
                        };
                      })
                      .find((item: any) => item.value == selectedSchool)}
                  />
                </Col>
                {selectedSchool?.length ? (
                  <>
                    <Col md={4} lg={3}>
                      <FormLabel className="fs-16 fw-500 text-dark">
                        {studentString.filterByClass}
                      </FormLabel>
                      <CustomSelectWhite
                        loading={loading}
                        options={
                          selectedClassOption.length
                            ? selectedClassOption.map((val: any) => {
                                return {
                                  value: val.reference,
                                  label: val.name,
                                  _id: val._reference,
                                  subjects: val.subjects,
                                };
                              })
                            : []
                        }
                        value={
                          selectedClass && selectedClass != null
                            ? {
                                value: selectedClass.reference,
                                label: selectedClass.label,
                                _id: selectedClass._reference,
                                subjects: selectedClass.subjects,
                              }
                            : null
                        }
                        onChange={(event: any) => {
                          handleClassChange(event);
                        }}
                        isClearable={true}
                        isMulti={false}
                      />
                    </Col>
                    <Col md={4} lg={3}>
                      <FormLabel className="fs-16 fw-500 text-dark">
                        {studentString.filterBySubject}
                      </FormLabel>
                      <CustomComponentSelect
                        options={
                          selectedSubjectList.length
                            ? selectedSubjectList.map((val: any) => {
                                return {
                                  value: val._id,
                                  label: val.name,
                                  _id: val._id,
                                  id: val._id,
                                  name: val.name,
                                  title: val.name,
                                };
                              })
                            : []
                        }
                        onChange={(event: any) => {
                          handleSubjectChange(event);
                        }}
                        value={
                          selectedSubject?.length
                            ? selectedSubject.map((val: any) => {
                                return {
                                  value: val._id,
                                  label: val.label,
                                  _id: val._id,
                                  id: val._id,
                                  name: val.name,
                                  title: val.name,
                                };
                              })
                            : null
                        }
                        isMulti={true}
                        hideSelectedOptions={false}
                        // options={productStatusJSON}
                        // isClearable={Object.keys(productState).length}
                      />
                    </Col>
                  </>
                ) : (
                  <></>
                )}
              </Row>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={12}>
          <Card className="border border-r10px">
            <Card.Body className="p-0">
              <div className="table-responsive">
                <table className="table table-rounded table-row-bordered align-middle gs-7 gy-4 mb-0">
                  <thead>
                    <tr className="fw-bold fs-16 fw-600 text-dark border-bottom h-70px align-middle gy-3">
                      <th className="min-w-175px ps-9">
                        {studentString.studentName}
                      </th>
                      <th className="min-w-175px text-center">
                        {studentString.class}
                      </th>
                      <th className="min-w-175px text-center">
                        {studentString.school}
                      </th>
                      <th className="min-w-175px text-center">
                        {studentString.dateOfBirth}
                      </th>
                      <th className="min-w-200px text-end"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <>
                        <td colSpan={5}>
                          <div className="w-100 d-flex justify-content-center">
                            <Loader loading={loading} />
                          </div>
                        </td>
                      </>
                    ) : (
                      <>
                        {studentData.length ? (
                          <>
                            {studentData.map(
                              (studentVal: any, teacherIndex: any) => {
                                return (
                                  <tr>
                                    <td>
                                      <div className="d-flex align-items-center flex-row">
                                        <div className="symbol symbol-50px border">
                                          <img
                                            className="img-fluid border-r8px object-fit-contain"
                                            src={
                                              studentVal?.image || defaultImg
                                            }
                                            alt=""
                                          />
                                        </div>
                                        {/* <span className="fs-15 fw-600 ms-3">
                                          {studentVal?.name}
                                          <br />
                                        </span> */}
                                        <div className="d-flex align-items-center flex-row">
                                          <span
                                            className="fs-15 fw-600 ms-3"
                                            style={{ maxWidth: "150px" }}
                                          >
                                            {studentVal?.name}
                                            <br />
                                            <span className="text-muted fw-semibold text-muted d-block fs-7">
                                              {studentVal?.grNumber}
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </td>
                                    <td style={{ maxWidth: "100px" }}>
                                      <div className="d-flex justify-content-center">
                                        <span className="fs-15 fw-600">
                                          {studentVal?.associatedSchool[0]
                                            ?.classDetails[0]?.class?.name +
                                            " - " +
                                            studentVal?.associatedSchool[0]
                                              ?.classDetails[0]?.classDivision
                                              ?.name}
                                        </span>
                                      </div>
                                    </td>
                                    <td
                                      style={{ maxWidth: "150px" }}
                                      className="text-center"
                                    >
                                      <span className="fs-15 fw-600">
                                        {
                                          studentVal?.associatedSchool[0]
                                            ?.school[0]?.name
                                        }
                                      </span>
                                    </td>
                                    <td>
                                      <div className="d-flex justify-content-center">
                                        <span className="fs-15 fw-600 text-dark">
                                          {Method.convertDateToDDMMYYYY(
                                            studentVal?.dateOfBirth
                                          )}
                                          {studentVal.date}
                                        </span>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="my-1 ms-5 float-end"></div>
                                      <div className="float-end">
                                        <button
                                          className="btn btn-primary"
                                          onClick={() => {
                                            handleStudent(studentVal);
                                          }}
                                        >
                                          {studentString.viewDetails}
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </>
                        ) : (
                          <tr>
                            <td colSpan={5}>
                              <div className="w-100 fs-15 fw-bold d-flex justify-content-center">
                                {studentString.noData}
                              </div>
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>
          {!loading && totalRecords > 0 ? (
            <Pagination
              totalRecords={totalRecords}
              currentPage={page}
              handleCurrentPage={handleCurrentPage}
              handleNextPage={handleNextPage}
              handlePreviousPage={handlePreviousPage}
              handlePageLimit={handlePageLimit}
              pageLimit={pageLimit}
            />
          ) : (
            <></>
          )}
        </Col>
      </Row>
    </>
  );
};
export default Students;
